module.exports = __webpack_public_path__ + "assets/img/ZT8351-M.16235c3f.png";